import { render, staticRenderFns } from "./TestingTab.vue?vue&type=template&id=02a81061&scoped=true&"
import script from "./TestingTab.vue?vue&type=script&lang=js&"
export * from "./TestingTab.vue?vue&type=script&lang=js&"
import style0 from "./TestingTab.vue?vue&type=style&index=0&id=02a81061&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a81061",
  null
  
)

export default component.exports